import './App.css';
import { useState, useEffect } from 'react';
import bank from './gifs/bank.gif';

function App() {
  const [isGifVisible, setGifVisible] = useState(false);

  const handleClick = () => {
    setGifVisible(prevState => {
      return !prevState;
    });
  };


  return (
    <div className="App" onClick={handleClick}>
      <Header />
      {isGifVisible && (
        <div className="gif-overlay">
          <img src={bank} alt="Bank GIF" className="full-screen-gif" />
          <div className="text-box nes-container is-rounded is-dark" style={{ position: 'absolute', width: '50%', height: '10%', top: '90%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>
            <p className="nes-text nes-text-custom">Bank is closed retard...</p>
          </div>
          <button 
            className="nes-btn" 
            onClick={(e) => {
              e.stopPropagation();
              setGifVisible(false);
            }} 
            style={{ position: 'absolute', top: '20px', right: '20px' }}
          >
            X
          </button>
        </div>
      )}
    </div>
  );
}

// New Header Component
function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title eight-bit-font">Tini Town</h1>
        <a href="https://x.com/tinicoin" className="nes-icon twitter is-large" aria-label="Twitter" target="_blank" rel="noopener noreferrer"></a>
      </div>
    </header>
  );
}

export default App;
